/// <reference path="../../main.js" />
define('viewmodels/Calculations/CalculationStatus',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/system', 'services/appsecurity', 'durandal/app'], function (ko, router, navigation, logger, system, appsecurity, app) {

    var CalculationViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        ScheduledJobStatusList: ko.observableArray(),
        ScheduledJobStatusListPCS: ko.observableArray(),
        SocializationJobStatusList: ko.observableArray(),
        OnDemandJobStatusList: ko.observableArray(),
        OnDemandJobStatusListPCS: ko.observableArray(),
        OnDemandSocializationJobStatusList: ko.observableArray(),
        BusinessUnitJobStatusList: ko.observableArray(),
        AssessmentTypeList: ko.observableArray(),
        SelectedAssessmentTypeFactor: ko.observableArray([]),
        RunCalculationPopUp: RunCalculationPopUp,
        RefreshScheduledJob: RefreshScheduledJob,
        RefreshOnDemandJob: RefreshOnDemandJob,
        RefreshBuJob: RefreshBuJob,
        
        RunPCSCalculations: RunPCSCalculations,
        GetSocializationJobStatus: GetSocializationJobStatus,
        RefreshSocializationJob: RefreshSocializationJob,
        RefreshOnDemandSocializationJob: RefreshOnDemandSocializationJob,
        CurrentYear: ko.observable(),
        Copyconfigurations: ko.observable(),
        CopyDataFromSourcetoDestinationyear: CopyDataFromSourcetoDestinationyear,
        TargetYear: ko.observable(),
        CancelSelectBuUnitPopUp: CancelSelectBuUnitPopUp,
        CalBussinessUnitList: ko.observableArray(),
        CalBusinessUnitListByAssessmentType: ko.observableArray([]),
        SaveBussinessUnitlist: ko.observableArray(),
        SelectBussinessUnitsPopUp: SelectBussinessUnitsPopUp,
        SelectBussinessUnitsPopUpPCS: SelectBussinessUnitsPopUpPCS,
        typedrpdownchange: typedrpdownchange,
        AssessmentTypeClickEvent: AssessmentTypeClickEvent,
        AssessmentTypeClickEventPCS: AssessmentTypeClickEventPCS,
        RunCalculations: RunCalculations,
        popUpTitle: ko.observable(),
        SelectAll: SelectAll,
        addPopUpCss: ko.observable(),
        ChangeYear: ChangeYear,
        BusinessUnitList: ko.observableArray(),
        RunCalculationsButtonDisable: ko.observable(false),
        RunCalculationsButtonDisablePCS: ko.observable(false),
        RunCalculationsSocializationButtonDisable: ko.observable(false),
        SelectBussinessUnitsPopUpSocialization: SelectBussinessUnitsPopUpSocialization,
        RunSocializationCopyOver: RunSocializationCopyOver,
        AssessmentTypeClickEventSocialization: AssessmentTypeClickEventSocialization,
        getRefreshProfileStatus: getRefreshProfileStatus,
        isRefreshProfile: ko.observable(false),
        SelectAll1: SelectAll1,
        SelectAllPCS: SelectAllPCS,
        ControlsAccess: ko.observable(false),

        RefreshScheduledJobPCS: RefreshScheduledJobPCS,
    };

    var ScheduledTableObj = false;
    var OnDemandTableObj = false;
    var OnSocializationDemandTableObj = false;
    var SocializationTableObj = false;
    var ScheduledTableObjPCS = false;
    return CalculationViewModel;

    function activate() {
        try {

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        CalculationViewModel.ControlsAccess(true);
                    }
                    else {
                        CalculationViewModel.ControlsAccess(false);
                    }
                });
            }
            else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                CalculationViewModel.ControlsAccess(true);
            }
            else {
                CalculationViewModel.ControlsAccess(false);
            }
            ScheduledTableObj = $('#tblScheduledJob').DataTable();
            SocializationTableObj = $('#tblSocializationJob').DataTable();
            ScheduledTableObjPCS = $('#tblScheduledJobPCS').DataTable();
            OnDemandTableObj = $('#tblOnDemandJob').DataTable();
            OnSocializationDemandTableObj = $('#tblOnSocializationDemandJob').DataTable();
            BuJobTableObjAML = $('#tblBuJobAML').DataTable();
            BuJobTableObjSANC = $('#tblBuJobSANC').DataTable();
            OnPCSDemandTableObj = $('#tblScheduledJobPCS').DataTable();
            $("#AssessmentTypeID").multiselect();
            $("#AssessmentTypeSocializationID").multiselect();
            GetScheduledJobStatus();
            GetSocializationJobStatus();
            GetScheduledJobStatusPCS();
            CalculationViewModel.Copyconfigurations(1);
            GetAllAssessmentTypes();
            getRefreshProfileStatus();
            BusinessUnitJobStatus();
            

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function BusinessUnitJobStatus() {

    }
    function typedrpdownchange(data, event) {
        try {
            if (event.currentTarget.value == 1) {
                document.getElementById('Response1').checked = true;
                document.getElementById('Response2').checked = false;
                CalculationViewModel.Copyconfigurations(1);
            }
            if (event.currentTarget.value == 0) {
                document.getElementById('Response1').checked = false;
                document.getElementById('Response2').checked = true;
                CalculationViewModel.Copyconfigurations(0);
            }
            return true;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: typedrpdownchange() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function getRefreshProfileStatus() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/checkRefreshProfileStatus",
                headers: headers,
                type: "POST"
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from getRefreshProfileStatus() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 1) {
                   CalculationViewModel.isRefreshProfile(true);
                }
                else{
                   CalculationViewModel.isRefreshProfile(false);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from CopyDataFromSourcetoDestinationyear() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                var msg = 'Exception: ' + error + ' | Source: ajaxSuccess from CopyDataFromSourcetoDestinationyear() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from CopyDataFromSourcetoDestinationyear() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }


    }


    function SelectBussinessUnitsPopUp() {
        try {
            CalculationViewModel.SelectedAssessmentTypeFactor([]);
            CalculationViewModel.RunCalculationsButtonDisable(false);
            $('#valfactorerror').hide();
            $('#SelectAssessmentType').show();
            $('#RiskFactorReorderTableDiv').hide();
            $('#BUUnittable').hide();
            $('#RunCalcButton').hide();
            $("#AssessmentTypeID").multiselect("refresh");
            CalculationViewModel.popUpTitle("Run Calculations");
            CalculationViewModel.addPopUpCss(true);
            GetCalcRunningAssessmentTypes().then(function () {
                $('#SelectBUunit').modal('show');
            });
            CalculationViewModel.SelectedAssessmentTypeFactor([]);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectBussinessUnitsPopUp() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function SelectBussinessUnitsPopUpPCS() {
        try {
            CalculationViewModel.SelectedAssessmentTypeFactor([]);
            CalculationViewModel.RunCalculationsButtonDisablePCS(false);
            $('#valfactorerror').hide();
            $('#SelectAssessmentType').show();
            $('#RiskFactorReorderTableDiv').hide();
            $('#BUUnittablePCS').hide();
            $('#RunCalcButtonPCS').hide();
            $("#AssessmentTypeID").multiselect();
            $("#AssessmentTypeIDPCS").multiselect();
            
            CalculationViewModel.popUpTitle("Run PCS Calculations");
            CalculationViewModel.addPopUpCss(true);
            $('#SelectBUunitPCS').modal('show');
            CalculationViewModel.SelectedAssessmentTypeFactor([]);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectBussinessUnitsPopUp() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }


    function SelectBussinessUnitsPopUpSocialization() {
        try {
            CalculationViewModel.SelectedAssessmentTypeFactor([]);
            CalculationViewModel.RunCalculationsSocializationButtonDisable(false);
            $('#valfactorerror').hide();
            $('#SelectSocializationAssessmentType').show();
            $('#RiskFactorReorderSocializationTableDiv').hide();
            $('#BUSocializationUnittable').hide();
            $('#RunSocializationButton').hide();
            $("#AssessmentTypeSocializationID").multiselect("refresh");
            CalculationViewModel.popUpTitle("Copy Socialization");
            CalculationViewModel.addPopUpCss(true);
            $('#SelectBUSocializationunit').modal('show');
            CalculationViewModel.SelectedAssessmentTypeFactor([]);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectBussinessUnitsPopUpSocialization() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function CopyDataFromSourcetoDestinationyear() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/CopyData?sourceyear=" + CalculationViewModel.CurrentYear() + "&destinationyear=" + CalculationViewModel.TargetYear() + "&Flag=0" + "&Is_Front_End=2",
                headers: headers,
                type: "POST"
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from CopyDataFromSourcetoDestinationyear() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 1) {
                    logger.logSuccess('Configurations have been copied successfully .', 'Success', system.getModuleId(CalculationViewModel), true);
                    CalculationViewModel.appsecurity.GetCurrentYearOfAssessment();
                    CalculationViewModel.CurrentYear(CalculationViewModel.TargetYear());
                    CalculationViewModel.TargetYear("");
                    GetScheduledJobStatus();
                    BusinessUnitJobStatus();
                }
                else if (jsonResult == -1) {
                    logger.logSuccess('Configurations already exist. Therefore, no data has been copied. Please contact your Administrator for further clarifications.', 'Success', system.getModuleId(CalculationViewModel), true);
                    CalculationViewModel.appsecurity.GetCurrentYearOfAssessment();
                    CalculationViewModel.CurrentYear(CalculationViewModel.TargetYear());
                    CalculationViewModel.TargetYear("");
                    GetScheduledJobStatus();
                    BusinessUnitJobStatus();
                }
                else
                    logger.logError('Error while Copying configurations. Please contact your Administrator', 'Error', system.getModuleId(CalculationViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from CopyDataFromSourcetoDestinationyear() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                var msg = 'Exception: ' + error + ' | Source: ajaxSuccess from CopyDataFromSourcetoDestinationyear() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from CopyDataFromSourcetoDestinationyear() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }
    }
    function SelectAll(data, event) {
        try {
            for (var i = 0; i < data.CalBusinessUnitListByAssessmentType().length; i++) {
                if (event.currentTarget.checked == true) {

                    data.CalBusinessUnitListByAssessmentType()[i].ToClear(true);

                }
                else {
                    $('#selectall').prop("checked", false);
                    data.CalBusinessUnitListByAssessmentType()[i].ToClear(false);
                }
            }
            var rows = $("#BUUnittable").dataTable().fnGetNodes();
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                if (event.currentTarget.checked == true)
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", true);
                else
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", false);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CancelSelectBuUnitPopUp() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function SelectAll1(data, event) {
        try {
            for (var i = 0; i < data.CalBusinessUnitListByAssessmentType().length; i++) {
                if (event.currentTarget.checked == true) {

                    data.CalBusinessUnitListByAssessmentType()[i].ToClear(true);

                }
                else {
                    $('#selectall1').prop("checked", false);
                    data.CalBusinessUnitListByAssessmentType()[i].ToClear(false);
                }
            }
            var rows = $("#BUUnittable").dataTable().fnGetNodes();
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                if (event.currentTarget.checked == true)
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", true);
                else
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", false);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CancelSelectBuUnitPopUp() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function SelectAllPCS(data, event) {
        try {
            for (var i = 0; i < data.CalBusinessUnitListByAssessmentType().length; i++) {
                if (event.currentTarget.checked == true) {

                    data.CalBusinessUnitListByAssessmentType()[i].ToClear(true);

                }
                else {
                    $('#SelectAllPCS').prop("checked", false);
                    data.CalBusinessUnitListByAssessmentType()[i].ToClear(false);
                }
            }
            var rows = $("#BUUnittablePCS").dataTable().fnGetNodes();
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                if (event.currentTarget.checked == true)
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", true);
                else
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", false);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CancelSelectBuUnitPopUp() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }



    function CancelSelectBuUnitPopUp(data, event) {
        try {
            $('#selectall').prop("checked", false);
            for (var i = 0; i < data.CalBussinessUnitList().length; i++) {
                data.CalBussinessUnitList()[i].ToClear(false);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CancelSelectBuUnitPopUp() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentTypeClickEvent(data, event) {
        try {
            if (CalculationViewModel.SelectedAssessmentTypeFactor().length === 0)
                $('#RunCalcButton').hide();
            else
                $('#RunCalcButton').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentTypeClickEvent() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentTypeClickEventPCS(data, event) {
        try {
            if (CalculationViewModel.SelectedAssessmentTypeFactor().length === 0)
                $('#RunCalcButtonPCS').hide();
            else
                $('#RunCalcButtonPCS').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentTypeClickEventPCS() method in CalculationStatus.js';
            logger.logMessage(msg);
        }

    }
    function AssessmentTypeClickEventSocialization(data, event) {
        try {
            if (CalculationViewModel.SelectedAssessmentTypeFactor().length === 0)
                $('#RunSocializationButton').hide();
            else
                $('#RunSocializationButton').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentTypeClickEvent() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function RunCalculations() {
        try {
            var ATString = "";
            for (var i = 0; i < CalculationViewModel.SelectedAssessmentTypeFactor().length; i++) {
                if (ATString === "")
                    ATString += CalculationViewModel.SelectedAssessmentTypeFactor()[i];
                else
                    ATString += "," + CalculationViewModel.SelectedAssessmentTypeFactor()[i];
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/RunCalculations?AssessmentTypeIds=" + ATString +
                    "&JobType=ON-DEMAND&OnlyClear=-1&AssessmentProfile=" + appsecurity.CurrentProfileOfAssessmentId(),
                headers: headers,
                type: "POST"
            })
                .success(function (jsonResult, error) {
                    if (jsonResult != null && jsonResult.startsWith('INC')) {
                        logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                    }
                    else if (jsonResult == '1') {
                        $('#SelectBUunit').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                        GetScheduledJobStatus("ON-DEMAND");
                        logger.logSuccess('Calculations have been initiated successfully', 'Success', system.getModuleId(CalculationViewModel), true);
                    }
                    else
                        logger.logError('An error has occurred. Please contact your Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);

                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while running the calculations. Please contact your Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RunCalculations() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }
    function GetAllAssessmentTypes() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAssessmentTypes",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            }).success(function (jsonResult, error) {

                CalculationViewModel.AssessmentTypeList([]);
                if (jsonResult != null) {

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                    }

                    var MappedAssessmentList = $.map(jsonResult, function (result) {
                        return new AssessmentListModel(result);
                    });
                    CalculationViewModel.AssessmentTypeList(MappedAssessmentList);
                }
            })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function GetCalcRunningAssessmentTypes() {
        try {
            return  $.ajax({
                url: "/api/Configuration/GetCalcRunningAssessmentTypes?SurveyId=-1&JobType=ON-DEMAND&AssessmentProfile=" + parseInt(appsecurity.CurrentProfileOfAssessmentId()),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            }).success(function (jsonResult, error) {

                if (jsonResult != null) {

                    if (jsonResult.length > 0) {
                        if (jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                        }
                        else {
                            //compare logic
                            for (let i = 0; i < CalculationViewModel.AssessmentTypeList().length; i++) {
                                for (let j = 0; j < jsonResult.length; j++) {
                                    if (CalculationViewModel.AssessmentTypeList()[i].AssessmentId() == jsonResult[j].AssessmentId) {
                                        $('#' + document.getElementsByName("multiselect_AssessmentTypeID")[i].id).attr("disabled", true);
                                        document.getElementsByName("multiselect_AssessmentTypeID")[i].parentElement.setAttribute("title", "Sync Ratings/Calculations are running for this assessment type. So please run calculations for this assessment type after sometime.");
                                        $('#' + document.getElementsByName("multiselect_AssessmentTypeID")[i].id).attr("title", "Sync Ratings/Calculations are running for this assessment type. So please run calculations for this assessment type after sometime.");
                                    }
                                }
                            }
                        }
                    }
                    else {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);

                    }
                }
                else {
                    logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);

                }
            })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetCalcRunningAssessmentTypes() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function RunSocializationCopyOver() {
        try {
            var ATString = "";
            for (var i = 0; i < CalculationViewModel.SelectedAssessmentTypeFactor().length; i++) {
                if (ATString === "")
                    ATString += CalculationViewModel.SelectedAssessmentTypeFactor()[i];
                else
                    ATString += "," + CalculationViewModel.SelectedAssessmentTypeFactor()[i];
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/RunSocializationCopyOver?AssessmentTypeIds=" + ATString +
                    "&JobType=ON-DEMAND",
                headers: headers,
                type: "POST"
            })
                .success(function (jsonResult, error) {
                    $('#SelectBUSocializationunit').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    GetSocializationJobStatus("ON-DEMAND");
                    logger.logSuccess('Socialization Copy Over has been initiated successfully', 'Success', system.getModuleId(CalculationViewModel), true);
                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while running the calculations. Please contact your Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RunSocializationCopyOver() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.AssessmentName = ko.observable(item.AssessmentName);
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.Description = ko.observable($('<div/>').html(item.Description).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }
    function RunPCSCalculations() {
        try {
            var ATString = "";
            for (var i = 0; i < CalculationViewModel.SelectedAssessmentTypeFactor().length; i++) {
                if (ATString === "")
                    ATString += CalculationViewModel.SelectedAssessmentTypeFactor()[i];
                else
                    ATString += "," + CalculationViewModel.SelectedAssessmentTypeFactor()[i];
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/RunCalculationsPCS?AssessmentTypeIds=" + ATString +
                    "&JobType=ON-DEMAND&OnlyClear=-1&AssessmentProfile=" + appsecurity.CurrentProfileOfAssessmentId(),
                headers: headers,
                type: "POST"
            })
                .success(function (jsonResult, error) {
                    if (jsonResult != null && jsonResult.startsWith('INC'))
                    {
                        logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                    }
                   else if (jsonResult == '1')
                    {
                        $('#SelectBUunitPCS').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                        GetScheduledJobStatusPCS("ON-DEMAND");
                        logger.logSuccess('Calculations have been initiated successfully', 'Success', system.getModuleId(CalculationViewModel), true);
                    }
                    else
                        logger.logError('An error has occurred. Please contact your Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while running the calculations. Please contact your Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RunCalculations() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function ChangeYear() {
        try {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/ChangeYear?CurrentYear=" + CalculationViewModel.CurrentYear() + "&ChangedYear=" + CalculationViewModel.TargetYear(),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from ChangeYear() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult == 1) {
                        CalculationViewModel.CurrentYear(CalculationViewModel.TargetYear());
                        logger.logSuccess('Year of Assessment has been changed successfully.', 'Success', system.getModuleId(CalculationViewModel), true);

                        CalculationViewModel.appsecurity.GetCurrentYearOfAssessment();
                        CalculationViewModel.CurrentYear(CalculationViewModel.TargetYear());
                        CalculationViewModel.TargetYear("");
                        GetScheduledJobStatus();
                        BusinessUnitJobStatus();
                    }

                    else if (jsonResult == 0) {
                        CalculationViewModel.CurrentYear(CalculationViewModel.TargetYear());
                        logger.logSuccess('Year of Assessment has been changed successfully.', 'Success', system.getModuleId(CalculationViewModel), true);
                        CalculationViewModel.appsecurity.GetCurrentYearOfAssessment();
                        CalculationViewModel.CurrentYear(CalculationViewModel.TargetYear());
                        CalculationViewModel.TargetYear("");
                        GetScheduledJobStatus();
                        BusinessUnitJobStatus();
                    }
                    else
                        logger.logError('An error while changing the current year of assessment. Please contact your Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from ChangeYear() method in CalculationStatus.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    var msg = 'Exception: ' + error + ' | Source: ajaxSuccess from ChangeYear() method in CalculationStatus.js';
                    logger.logMessage(msg);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from ChangeYear() method in CalculationStatus.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail from ChangeYear() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }


    function GetScheduledJobStatus() {
        try {
            JobType = "SCHEDULED";
            if (JobType == "SCHEDULED") {
                $('#loadingMainImgSchDiv').show();
                $('#tblScheduledJob').hide();
            }
            else {
                $('#loadingMainImgOdDiv').show();
                $('#tblOnDemandJob').hide();
            }
            $.ajax({
                url: "/api/Calculation/GetJobStatus?JobType=BOTH",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetScheduledJobStatus() method in CalculationStatus.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                    }

                    if (JobType == "SCHEDULED") {
                        $('#loadingMainImgSchDiv').hide();
                        $('#tblScheduledJob').show();
                        CalculationViewModel.ScheduledJobStatusList([]);
                        ScheduledTableObj.destroy();
                        $('#tblScheduledJob tbody tr').remove();
                        var MappedScheduledJobStatus = $.map(jsonResult, function (result) {
                            return new JobStatusModel(result);
                        });
                        CalculationViewModel.ScheduledJobStatusList(MappedScheduledJobStatus);
                        $('#btnRunCalculations').attr( "disabled", false );
                        for (var i = 0; i < CalculationViewModel.ScheduledJobStatusList().length; i++) {
                            if (CalculationViewModel.ScheduledJobStatusList()[i].JobRunStatus() === "In-Progress") {
                                $('#btnRunCalculations').attr("disabled", true);
                            }
                        }
                        ScheduledTableObj = $('#tblScheduledJob').DataTable({
                            "aLengthMenu": [10, 25, 50, 100],
                            "iDisplayLength": 10,
                            "aoColumndefs": [{
                                "aTargets": [2],
                                "bSortable": false
                            }]
                        });
                    }
                    else {
                        $('#loadingMainImgOdDiv').hide();
                        $('#tblOnDemandJob').show();
                        CalculationViewModel.OnDemandJobStatusList([]);
                        OnDemandTableObj.destroy();
                        $('#tblOnDemandJob tbody tr').remove();
                        var MappedOnDemandJobStatus = $.map(jsonResult, function (result) {
                            return new JobStatusModel(result);
                        });
                        CalculationViewModel.OnDemandJobStatusList(MappedOnDemandJobStatus);
                        OnDemandTableObj = $('#tblOnDemandJob').DataTable({
                            "aLengthMenu": [5, 10, 15, 20],
                            "iDisplayLength": 5,
                            "aoColumndefs": [{
                                "aTargets": [2],
                                "bSortable": false
                            }]
                        });
                    }
                }
                else
                    logger.logError('An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetScheduledJobStatus() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetScheduledJobStatus() method in CalculationStatus.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetScheduledJobStatus() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }
    }

    // Socialization Job Status Code Begin

    function GetSocializationJobStatus() {
        try {
            JobType = "SCHEDULED";
            if (JobType == "SCHEDULED") {
                $('#loadingMainImgSchDiv1').show();
                $('#tblSocializationJob').hide();
            }
            else {
                $('#loadingMainImgOdDiv1').show();
                $('#tblOnSocializationDemandJob').hide();
            }
            $.ajax({
            url: "/api/Calculation/GetSocializationJobStatus?JobType=SOC - COPY",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetScheduledJobStatus() method in CalculationStatus.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                    }

                    if (JobType == "SCHEDULED") {
                        $('#loadingMainImgSchDiv1').hide();
                        $('#tblSocializationJob').show();
                        CalculationViewModel.SocializationJobStatusList([]);
                        SocializationTableObj.destroy();
                        $('#tblSocializationJob tbody tr').remove();
                        var MappedSocializationJobStatus = $.map(jsonResult, function (result) {
                            return new JobStatusModel(result);
                        });
                        CalculationViewModel.SocializationJobStatusList(MappedSocializationJobStatus);
                        $('#btnCopySocialization').attr("disabled", false);
                        for (var i = 0; i < CalculationViewModel.SocializationJobStatusList().length; i++) {
                            if (CalculationViewModel.SocializationJobStatusList()[i].JobRunStatus() !== "Failed") {
                                $('#btnCopySocialization2').show();
                                $('#btnCopySocialization').hide();
                                $('#btnCopySocialization2').click(function () {
                                    $('#socializationAlreadyCopied').modal('show');
                                });
                            }
                        }
                        SocializationTableObj = $('#tblSocializationJob').DataTable({
                            "aLengthMenu": [10, 25, 50, 100],
                            "iDisplayLength": 10,
                            "aoColumndefs": [{
                                "aTargets": [2],
                                "bSortable": false
                            }]
                        });
                    }
                    else {
                        $('#loadingMainImgOdDiv1').hide();
                        $('#tblOnSocializationDemandJob').show();
                        CalculationViewModel.OnDemandSocializationJobStatusList([]);
                        OnSocializationDemandTableObj.destroy();
                        $('#tblOnSocializationDemandJob tbody tr').remove();
                        var MappedOnDemandJobStatus = $.map(jsonResult, function (result) {
                            return new JobStatusModel(result);
                        });
                        CalculationViewModel.OnDemandSocializationJobStatusList(MappedOnDemandJobStatus);
                        OnSocializationDemandTableObj = $('#tblOnSocializationDemandJob').DataTable({
                            "aLengthMenu": [5, 10, 15, 20],
                            "iDisplayLength": 5,
                            "aoColumndefs": [{
                                "aTargets": [2],
                                "bSortable": false
                            }]
                        });
                    }
                }
                else
                    logger.logError('An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetSocializationJobStatus() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSocializationJobStatus() method in CalculationStatus.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSocializationJobStatus() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetScheduledJobStatusPCS() {
        try {
            JobTypePCS = "SCHEDULED";
            if (JobTypePCS == "SCHEDULED") {
                $('#loadingMainImgSchDiv').show();
                $('#tblScheduledJobPCS').hide();
            }
            else {
                $('#loadingMainImgOdDiv').show();
                $('#tblOnDemandJob').hide();
            }
            $.ajax({
                url: "/api/Calculation/GetJobStatusPCS?JobType=BOTH",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetScheduledJobStatus() method in CalculationStatus.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
                    }

                    if (JobTypePCS == "SCHEDULED") {
                        $('#loadingMainImgSchDiv').hide();
                        $('#tblScheduledJobPCS').show();
                        CalculationViewModel.ScheduledJobStatusListPCS([]);
                        ScheduledTableObjPCS.destroy();
                        $('#tblScheduledJobPCS tbody tr').remove();
                        var MappedScheduledJobStatusPCS = $.map(jsonResult, function (result) {
                            return new JobStatusModelPCS(result);
                        });
                        CalculationViewModel.ScheduledJobStatusListPCS(MappedScheduledJobStatusPCS);
                        $('#btnRunCalculationsPCS').attr("disabled", false);
                        for (var i = 0; i < CalculationViewModel.ScheduledJobStatusListPCS().length; i++) {
                            if (CalculationViewModel.ScheduledJobStatusListPCS()[i].JobRunStatus() === "In-Progress") {
                                $('#btnRunCalculationsPCS').attr("disabled", true);
                            }
                        }
                        ScheduledTableObjPCS = $('#tblScheduledJobPCS').DataTable({
                            "aLengthMenu": [10, 25, 50, 100],
                            "iDisplayLength": 10,
                            "aoColumndefs": [{
                                "aTargets": [2],
                                "bSortable": false
                            }],
                            "bDestroy": true
                        });
                    }
                    else {
                        $('#loadingMainImgOdDiv').hide();
                        $('#tblOnDemandJob').show();
                        CalculationViewModel.OnDemandJobStatusListPCS([]);
                        OnDemandTableObj.destroy();
                        $('#tblOnDemandJob tbody tr').remove();
                        var MappedOnDemandJobStatus = $.map(jsonResult, function (result) {
                            return new JobStatusModel(result);
                        });
                        CalculationViewModel.OnDemandJobStatusListPCS(MappedOnDemandJobStatus);
                        OnDemandTableObj = $('#tblOnDemandJob').DataTable({
                            "aLengthMenu": [5, 10, 15, 20],
                            "iDisplayLength": 5,
                            "aoColumndefs": [{
                                "aTargets": [2],
                                "bSortable": false
                            }],
                             "bDestroy": true
                        });
                    }
                }
                else
                    logger.logError('An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetScheduledJobStatus() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetScheduledJobStatus() method in CalculationStatus.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetScheduledJobStatusPCS() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }
    }

    //function GetScheduledJobStatusPCS() {
    //    try {
    //        CalculationViewModel.ScheduledJobStatusListPCS([]);
    //        OnPCSDemandTableObj.destroy();
    //        //$('#tblOnSocializationDemandJob tbody tr').remove();
    //        //var MappedOnDemandJobStatus = $.map(jsonResult, function (result) {
    //        //    return new JobStatusModel(result);
    //        //});
    //       // CalculationViewModel.OnDemandSocializationJobStatusList(MappedOnDemandJobStatus);
    //        OnPCSDemandTableObj = $('#tblScheduledJobPCS').DataTable({
    //            "aLengthMenu": [5, 10, 15, 20],
    //            "iDisplayLength": 5,
    //            "aoColumndefs": [{
    //                "aTargets": [2],
    //                "bSortable": false
    //            }]
    //        });
    //    }
    //    catch (e) {
    //        var msg = 'Exception: ' + e + ' | Source: GetScheduledJobStatusPCS() method in CalculationStatus.js';
    //        logger.logMessage(msg);
    //    }
    //}
    // Socialization Job Status Code End

    function RunCalculationPopUp() {
        try {
            app.showMessage('Are you sure you want to Run the Calculations?', 'Confirm Risk Assessment Calculation', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        $('#CalculationSplash').modal('show');
                        RunCalculation();
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RunCalculationPopUp() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function RunCalculation() {
        CalculationViewModel.BusinessUnitList([]);

        for (var i = 0; i < CalculationViewModel.SelectedAssessmentTypeFactor().length; i++) {
            CalculationViewModel.BusinessUnitList.push({
                Comments: CalculationViewModel.SelectedAssessmentTypeFactor()[i]
            });
        }
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/RunRiskEngine?JobType=ON-DEMAND",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(CalculationViewModel.BusinessUnitList(), function (result) { return { Comments: result.Comments } }))


            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in RunCalculation() method in CalculationStatus.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                $('#CalculationSplash').modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                GetScheduledJobStatus("ON-DEMAND");
                BusinessUnitJobStatus();
                if (jsonResult == 1) {
                    logger.logSuccess('Calculations have been initiated.', 'Success', system.getModuleId(CalculationViewModel), true);
                }
                else
                    logger.logError('An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(CalculationViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in RunCalculation() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in RunCalculation() method in CalculationStatus.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in RunCalculation() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }
    }

    function RefreshScheduledJob() {
        try {
            GetScheduledJobStatus('SCHEDULED');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RefreshScheduledJob() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function RefreshOnDemandJob() {
        try {
            GetScheduledJobStatus('ON-DEMAND');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RefreshOnDemandJob() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }


    function RefreshSocializationJob() {
        try {
            GetSocializationJobStatus('SCHEDULED');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RefreshSocializationJob() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function RefreshOnDemandSocializationJob() {
        try {
            GetSocializationJobStatus('ON-DEMAND');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RefreshOnDemandSocializationJob() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function RefreshBuJob() {
        try {
            BusinessUnitJobStatus();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RefreshBuJob() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    
    function RefreshScheduledJobPCS() {
        try {
            GetScheduledJobStatusPCS('ON-DEMAND');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RefreshScheduledJobPCS() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }
    //---------------------------------------------------Model Definition Starts Here-----------------------------------------------------------------------------------
    function JobStatusModel(item) {
        try {
            var self = this;
            self.JobId = ko.observable(item.JobId);
            self.JobRunDate = ko.observable(item.JobRunDate);
            self.JobEndDate = ko.observable(item.JobEndDate);
            self.JobRunBy = ko.observable(item.JobRunBy);
            self.JobType = ko.observable(item.JobType);
            self.JobRunStatus = ko.observable(item.JobStatus);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: JobStatusModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    function JobStatusModelPCS(item) {
        try {
            var self = this;
            self.JobId = ko.observable(item.JobId);
            self.JobRunDate = ko.observable(item.JobRunDate);
            self.JobEndDate = ko.observable(item.JobEndDate);
            self.JobRunBy = ko.observable(item.JobRunBy);
            self.JobType = ko.observable(item.JobType);
            self.JobRunStatus = ko.observable(item.JobStatus);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: JobStatusModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }
    function CalculatedBussinessUnitModel(item) {
        try {
            var self = this;
            self.BuId = ko.observable(item.BuId);
            self.BuName = ko.observable($('<div/>').html(item.BuName).text());
            self.BuAssessmentTypeId = ko.observable(item.BuAssessmentTypeId);
            self.BuAssessmentTypeName = ko.observable($('<div/>').html(item.BuAssessmentTypeName).text());
            self.ToClear = ko.observable(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CalculatedBussinessUnitModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }
    function BusinessUnitJobModel(item) {
        try {
            var self = this;

            self.BusinessUnitId = ko.observable(item.BusinessUnitId);
            self.BusinessUnitName = ko.observable($('<div/>').html(item.BusinessUnitName).text());
            self.QTDRRunDate_AML = ko.observable($('<div/>').html(item.QTDRRunDate_AML).text());
            self.QTDRRunStatus_AML = ko.observable($('<div/>').html(item.QTDRRunStatus_AML).text());
            self.QTDRRunDate_SANC = ko.observable($('<div/>').html(item.QTDRRunDate_SANC).text());
            self.QTDRRunStatus_SANC = ko.observable($('<div/>').html(item.QTDRRunStatus_SANC).text());
            self.QLDRRunDate_AML = ko.observable($('<div/>').html(item.QLDRRunDate_AML).text());
            self.QLDRRunStatus_AML = ko.observable($('<div/>').html(item.QLDRRunStatus_AML).text());
            self.QLDRRunDate_SANC = ko.observable($('<div/>').html(item.QLDRRunDate_SANC).text()); ko.observable(item.QLDRRunDate_SANC);
            self.QLDRRunStatus_SANC = ko.observable($('<div/>').html(item.QLDRRunStatus_SANC).text());
            self.ACDRRunDate = ko.observable($('<div/>').html(item.ACDRRunDate).text());
            self.ACDRRunStatus = ko.observable($('<div/>').html(item.ACDRRunStatus).text());
            self.SCDRRunDate = ko.observable($('<div/>').html(item.SCDRRunDate).text());
            self.SCDRRunStatus = ko.observable($('<div/>').html(item.SCDRRunStatus).text());
            self.ARDRRunDate = ko.observable($('<div/>').html(item.ARDRRunDate).text());
            self.ARDRRunStatus = ko.observable($('<div/>').html(item.ARDRRunStatus).text());
            self.SRDRRunDate = ko.observable($('<div/>').html(item.SRDRRunDate).text());
            self.SRDRRunStatus = ko.observable($('<div/>').html(item.SRDRRunStatus).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnitJobModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    //---------------------------------------------------Model Definition Starts Here-----------------------------------------------------------------------------------
});
